import React, {useEffect, useState} from "react";
import TaskRevisions from "./TaskRevisions";
import {Form} from "react-bootstrap";
import {isAdministrator} from "../../../utils/UserInfo";
import {Divider, Button, Col, Row} from "antd";
import {getChecklistRevisions, getTaskTypes} from "../../../api";

function ChecklistRevisions(props)
{
    const [checklistRevisions, setChecklistRevisions] = useState([]);
    const [taskGroup, setTaskGroup] = useState('');
    const [checkList, setCheckList] = useState(null);
    const [revision, setRevision] = useState(null);
    const [selectChecklistId, setSelectChecklistId] = useState(null);
    const [selectChecklistName, setSelectChecklistName] = useState(null);
    const [selectRevNo, setSelectRevNo] = useState(null);
    const [selectRevStatus, setSelectRevStatus] = useState(null);
    const [selectTaskGroup, setSelectTaskGroup] = useState(null);
    const [taskTypes, setTaskTypes] = useState([]);

    useEffect(() => {
        refreshChecklistData('', null, null);
    }, []);

    function refreshChecklistData(grp,chkId, rev)
    {
        async function getData() {
            let revisions = await getChecklistRevisions();
            setChecklistRevisions(revisions.data);
            let types = await getTaskTypes();
            setTaskTypes(types.data);
        }
        getData();
        setTaskGroup('');
        setCheckList(null);
        setRevision(null);
    }
    const onTaskGroupChange = (e) => {
        const { value } = e.target;
        if (value !== null || value !== '') {
            setTaskGroup(value);
        }
        setCheckList(null);
        if(value === 'PE')
        {
            let c = checklistRevisions.find(t=>t.checklistId===32);
            setCheckList(c);

        }
        setRevision(null);
    }
    const onChecklistChange = (e) => {
        const { value } = e.target;
        if (value !== null || value !== '') {
            let c = checklistRevisions.find(t=>t.checklistId===Number(value));
            setCheckList(c);
        }
        setRevision(null);
    }
    const onRevisionChange = (e) => {
        const { value } = e.target;
        if (value !== null || value !== '') {
            let r = checkList?.checkListRevisions.find(t=>t.revisionNo===Number(value));
            setRevision(r);
        }
    }

    return (
       <div>
           <h4>Select the Task Group, Checklist Section, and Revision to view the task template data.</h4><br/>
           <Row justify='left' align='middle'>
               <Col sm={4} style={{ alignItems: 'end' }}>
                   <h6>Select Task Group:</h6>
               </Col>
               <Col sm={4} style={{ alignItems: 'end' }}>
                   <h6>Select Checklist Section:</h6>
               </Col>
               <Col sm={4} style={{ alignItems: 'end' }}>
                   <h6>Select Revision:</h6>
               </Col>
           </Row>
           <Row>
               <Col sm={4} style={{ alignItems: 'end' }}>
                       <Form.Control as='select' id='task_group-selector' value={taskGroup}
                                     style={{ height: '36px' }}
                           onChange={onTaskGroupChange}
                       >
                           <option value={''}></option>
                           <option value={'PR'}>Project Tasks</option>
                           <option value={'AT'}>Asset Tasks</option>
                           <option value={'PE'}>Pre-E Form Tasks</option>
                       </Form.Control>
                   </Col>
               <Col sm={4} style={{ alignItems: 'end' }}>
                       <Form.Control as='select' id='section-selector' value={checkList?checkList.checklistId:''}
                                     style={{ height: '36px' }}
                           onChange={onChecklistChange}
                       >
                           {taskGroup!=='PE' && <option value={''}></option>}
                           {checklistRevisions.filter(t=>t.taskGroup===taskGroup).map((rev, index) => (
                               <option
                                   id={'checklist-'+rev.checklistId}
                                   key={rev.checklistId}
                                   value={rev.checklistId}
                               >{rev.checklistName}
                               </option>
                           ))}
                       </Form.Control>
                   </Col>
               <Col sm={4} style={{ alignItems: 'end' }}>
               <Form.Control as='select' id='revision-selector' value={revision?revision.revisionNo:''}
                                     style={{ height: '36px' }}
                                     onChange={onRevisionChange}
                       >
                           <option value={''}></option>
                           {checkList?.checkListRevisions.map((rev, index) => (
                               <option
                                   id={'checklist-'+rev.checklistId+'-rev-'+rev.revisionNo}
                                   key={rev.revisionNo}
                                   value={rev.revisionNo}
                               >{rev.revisionStatus==='D' ? (rev.revisionNo+' (DRAFT)') :
                                   (checkList?.currentRevision===rev.revisionNo ? (rev.revisionNo+' (CURRENT)') : rev.revisionNo)}
                               </option>
                           ))}
                       </Form.Control>
                   </Col>
               {revision !== null &&
               <Col sm={6} style={{ alignItems: 'end' }}>
                   <Button
                       style={{height: 'auto'}}
                       type='primary'
                       onClick={async () => {
                           setSelectChecklistId(Number(revision?.checklistId));
                           setSelectChecklistName(checkList?.checklistName);
                           setSelectRevNo(Number(revision?.revisionNo));
                           setSelectRevStatus(revision?.revisionStatus);
                           setSelectTaskGroup(taskGroup);
                       }}
                   >
                       {revision?.revisionStatus==='A' ? 'View Revision' : (isAdministrator() ? 'View/Edit Draft' : 'View Draft')}
                   </Button>
                   {'  '}
                   {isAdministrator() && checkList && !checkList.checkListRevisions.find(t=>t.revisionStatus==='D') &&
                   checkList?.currentRevision===revision?.revisionNo &&
                   <Button
                       style={{height: 'auto'}}
                       type='primary'
                       onClick={async () => {
                           setSelectChecklistId(Number(revision?.checklistId));
                           setSelectChecklistName(checkList?.checklistName);
                           setSelectRevNo(Number(revision?.revisionNo));
                           setSelectRevStatus('N'); // new version
                           setSelectTaskGroup(taskGroup);
                       }}
                   >
                       Create New Draft
                   </Button>
                   }
               </Col>
               }
               </Row>
           <Row><Divider /></Row>
           { selectTaskGroup !== null && selectChecklistId !== null && selectRevNo !== null &&
           <TaskRevisions checklistId={selectChecklistId}
                          checklistName={selectChecklistName}
                          taskGroup={selectTaskGroup}
                          revisionNo={selectRevNo}
                          revisionStatus={selectRevStatus}
                          refreshChecklistData={refreshChecklistData}
                          taskTypes={taskTypes.filter(t => selectTaskGroup==='PR'?t.projectTask==='Y':(selectTaskGroup==='AT'?t.assetTask!==null:t.formTask!==null))}
               />
           }
        </div>
    )
}

export default ChecklistRevisions;